export default {
  authenticated: () => import("/builds/nht4944308/brands/afrimarkets/webapp/layouts/authenticated.vue").then(m => m.default || m),
  default: () => import("/builds/nht4944308/brands/afrimarkets/webapp/layouts/default.vue").then(m => m.default || m),
  error: () => import("/builds/nht4944308/brands/afrimarkets/webapp/layouts/error.vue").then(m => m.default || m),
  unauthenticated: () => import("/builds/nht4944308/brands/afrimarkets/webapp/layouts/unauthenticated.vue").then(m => m.default || m)
}